import { getter, component, prop } from '../../decorators';

import { OPENER_MIXIN as OpenerMixin } from '../../mixins/opener.mixin';

import includes from 'lodash/includes';
import first from 'lodash/first';

import l10n from '@/transformers/l10n';

@component({
   mixins: [ OpenerMixin ],
   watch: { carts: 'selectFirstIfNeeded' }
})
export default class AddToCart {
   newName = '';

   @prop({ required: true }) clipId
   @prop({ type: Boolean, default: true }) clearName
   @prop({ type: Boolean, default: false }) selectFirst

   @getter('getActiveCartList') carts

   get addTitle() {
      return l10n('cart.add');
   }

   get createTitle() {
      return l10n('cart.create');
   }

   get createNewTitle() {
      return l10n('cart.create_new');
   }

   addTo(cart) {
      if (this.isContainsCurrentClip(cart)) {
         return;
      }
      this.$emit('add-to', cart);
      setTimeout(this.deactivate);
   }

   async addToNew() {
      const cart = { name: this.newName, clipIds: [], clipsLanguages: [] };
      this.addTo(cart);
      this.newName = this.clearName ? '' : this.newName;
   }

   nameForCart(cart) {
      const msg = l10n('cart.contains_clip', { cartName: cart.name });
      return this.isContainsCurrentClip(cart) ? msg : '';
   }

   isContainsCurrentClip(cart) {
      const clipId = +this.clipId;
      const userLang = this.$store.getters.language;
      return cart.clipIds.some((cid, idx) => {
         if (clipId === cid) {
            const lang = cart.clipsLanguages[idx];
            return lang === userLang;
         }
         return false;
      });
   }

   selectFirstIfNeeded() {
      if (this.selectFirst && this.carts.length) {
         this.addTo(first(this.carts));
      }
   }

   mounted() {
      this.$nextTick(this.selectFirstIfNeeded);
   }
}

